const switchIcon = '<svg style="pointer-events:none;display:inline-block;height:10px;" xmlns="http://www.w3.org/2000/svg" viewBox="3.5 4.02 13 12.02"><path d="M13.25 8a.75.75 0 0 0 0-1.5h-7.19l1.22-1.22a.75.75 0 0 0-1.06-1.06l-2.5 2.5a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 1 0 1.06-1.06l-1.22-1.22h7.19Z"></path><path d="M6.75 13.5a.75.75 0 0 1 0-1.5h7.19l-1.22-1.22a.75.75 0 1 1 1.06-1.06l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l1.22-1.22h-7.19Z"></path></svg>'
const toggleOnIcon =  '<svg style="pointer-events:none;display:inline-block;height:10px;" xmlns="http://www.w3.org/2000/svg" viewBox="2.5 4.5 15 11"><path d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path fill-rule="evenodd" d="M8 4.5a5.5 5.5 0 1 0 0 11h4a5.5 5.5 0 1 0 0-11h-4Zm-4 5.5a4 4 0 0 1 4-4h4a4 4 0 0 1 0 8h-4a4 4 0 0 1-4-4Z"></path></svg>'
const toggleOffIcon = '<svg style="pointer-events:none;display:inline-block;height:10px;" xmlns="http://www.w3.org/2000/svg" viewBox="2.5 4.5 15 11"><path d="M8 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"></path><path fill-rule="evenodd" d="M8 4.5a5.5 5.5 0 1 0 0 11h4a5.5 5.5 0 1 0 0-11h-4Zm-4 5.5a4 4 0 0 1 4-4h4a4 4 0 0 1 0 8h-4a4 4 0 0 1-4-4Z"></path></svg>'

window.vatSelector = window.vatSelector || {};

window.vatSelector = {
    "status" : true,
    "displayPopup" : true,
    "defaultLocale" : Shopify.locale,
    "defaultCountry" : Shopify.country,
    "priceSelector" : "span.vat-selector-currency ",
    "themeSettings" : [{"helperText":true,"helperOption":"switch","switcherType":"two","defaultPricing":"b2c","includingTax":false,"cookie_validity":364,"parenthesis_one":" ","parenthesis_two":" ","toggleOnBgColor":"#efefef","toggleOffBgColor":"#ffffff","toggleCircleBgColor":"#000000","toggleBorderColor":"#333333"}],
    "translations" : {"sv":{"b2bButton":"Företag","b2bHelper":"exkl. moms","b2cButton":"Privatperson","b2cHelper":"inkl. moms","popupTitle":"Välkommen till Buyn!","popupSubtitle":"Handlar du som:"}},
    "taxConfig" : {"SE":{"country_name":"Sweden","single_tax":true,"tax_amount":25}},
    "moneyFormat" : "{{ amount_no_decimals_with_space_separator }} kr",
    "moneyWithCurrencyFormat" : "{{ amount_no_decimals_with_space_separator }} kr",
    "currencyCodeEnabled" : false,
    "live_preview" : false
}

if (Shopify.designMode) {
    if(window.vatSelector.live_preview){
        setTimeout( function(){
        document.querySelector(".vat-selector-popup").style.display = "block";
        }, 500);
    } else {
        setTimeout( function(){
        document.querySelector(".vat-selector-popup").style.display = "none";
        }, 500);
    }
}

if (window.vatSelector.status) {
    console.log ("VAT Selector is active")
	function checkNullUndefined(e) {
		return null != e;
	}

	function vatCreateCookie(e, t, n) {
		if (n) {
			var a = new Date();
			a.setTime(a.getTime() + 24 * n * 60 * 60 * 1e3);
			var c = "; expires=" + a.toGMTString();
		} else c = "";
		document.cookie = e + "=" + t + c + "; path=/";
	}

	function vatReadCookie(e) {
		for (
			var t = e + "=", n = document.cookie.split(";"), a = 0; a < n.length; a++
		) {
			for (var c = n[a];
				" " == c.charAt(0);) c = c.substring(1, c.length);
			if (0 == c.indexOf(t)) return c.substring(t.length, c.length);
		}
		return null;
	}

	function vatEraseCookie(e) {
		vatCreateCookie(e, "", -1);
	}

	function readAppStatus() {
		return window.vatSelector.status;
	}

	function readCountry() {
		return Shopify.country;
	}

	function readTaxAmount() {
		var e = readCountry(),
			t = window.vatSelector.taxConfig[e];
	
		if (!checkNullUndefined(t)) {
			console.log("Tax config for the selected country is not defined.");
			return false;
		}
		return t.tax_amount;
	}

	function readTranslations() {
		var e = document.documentElement.lang;
		if (
			checkNullUndefined(e) &&
			checkNullUndefined(window.vatSelector.translations[e])
		) {
			return window.vatSelector.translations[e];
		} else {
			return window.vatSelector.translations[
				Object.keys(window.vatSelector.translations)["0"]
			];
		}
	}

	function readThemeSettings() {
		return window.vatSelector.themeSettings[
			Object.keys(window.vatSelector.themeSettings)["0"]
		];
	}

	function changeAllHelper(e) {
		let a = readThemeSettings();
		document.querySelectorAll(".vat-price-helper").forEach(function(t) {
			t.innerHTML = `${e.includes("exkl") ? toggleOffIcon : toggleOnIcon}${a.parenthesis_one}${e}${a.parenthesis_two}`;
		});
	}

	function changeAllText(e, t) {
		document.querySelectorAll(e).forEach(function(e) {
			e.innerHTML = t;
		});
	}

	function changeLanguage(e) {
		changeAllText(".vat-selector-info h2", e.popupTitle);
		changeAllText(".vat-selector-info p", e.popupSubtitle);
		changeAllText(
			".vat-selector-account.company button.account-type",
			e.b2bButton
		);
		changeAllText(".vat-selector-account.company p.description", e.b2bHelper);
		changeAllText(
			".vat-selector-account.private button.account-type",
			e.b2cButton
		);
		changeAllText(".vat-selector-account.private p.description", e.b2cHelper);
		if (document.querySelector(".vat-selector-inline") !== null) {
			changeAllText(
				'.vat-selector-inline [data-vat-type="b2b"] h2',
				e.b2bButton
			);
			changeAllText(
				'.vat-selector-inline [data-vat-type="b2b"] p',
				e.b2bHelper
			);
			changeAllText(
				'.vat-selector-inline [data-vat-type="b2c"] h2',
				e.b2cButton
			);
			changeAllText(
				'.vat-selector-inline [data-vat-type="b2c"] p',
				e.b2cHelper
			);

			// For toggle switch
			changeAllText(
				'.vat-selector-inline .vat-selector-option [data-vat-type="b2b"]',
				e.b2bButton
			);
			changeAllText(
				'.vat-selector-inline .vat-selector-option [data-vat-type="b2b"] span',
				e.b2bHelper
			);
			changeAllText(
				'.vat-selector-inline .vat-selector-option [data-vat-type="b2c"]',
				e.b2cButton
			);
			changeAllText(
				'.vat-selector-inline .vat-selector-option [data-vat-type="b2c"] span',
				e.b2cHelper
			);
		}
	}

	function formatMoney(cents, format = "") {
		if (typeof cents === "string") {
			cents = cents.replace(".", "");
		}
		let value = "";
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = format;

		function formatWithDelimiters(
			number,
			precision = 2,
			thousands = ",",
			decimal = "."
		) {
			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			const parts = number.split(".");
			const dollarsAmount = parts[0].replace(
				/(\d)(?=(\d\d\d)+(?!\d))/g,
				`$1${thousands}`
			);
			const centsAmount = parts[1] ? decimal + parts[1] : "";

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case "amount":
				value = formatWithDelimiters(cents, 2);
				break;
			case "amount_no_decimals":
				value = formatWithDelimiters(cents, 0);
				break;
			case "amount_with_space_separator":
				value = formatWithDelimiters(cents, 2, " ", ",");
				break;
			case "amount_with_comma_separator":
				value = formatWithDelimiters(cents, 2, ".", ",");
				break;
			case "amount_no_decimals_with_comma_separator":
				value = formatWithDelimiters(cents, 0, ".", ",");
				break;
			case "amount_no_decimals_with_space_separator":
				value = formatWithDelimiters(cents, 0, " ");
				break;
			case "amount_with_apostrophe_separator":
				value = formatWithDelimiters(cents, 2, "'", ".");
				break;
		}

		if (formatString.indexOf("with_comma_separator") !== -1) {
			return formatString.replace(placeholderRegex, value);
		} else {
			return formatString.replace(placeholderRegex, value);
		}
	}

	function getPrice(e, t, n) {
		var formats = window.vatSelector.currencyCodeEnabled ?
			window.vatSelector.moneyWithCurrencyFormat :
			window.vatSelector.moneyFormat;
		var checkComma = t.indexOf(",");
		var checkDot = t.indexOf(".");
		var a = t.replace(/[^0-9]/g, "");
		var c = t
			.replace(/[0-9]/, "__")
			.replace(/\d+([,.]\d+)?/g, "")
			.replace(/,/g, "")
			.replace(/\./g, "");
		if (e == "b2b") {
			var b = ((100 * parseInt(a)) / (100 + parseFloat(n))).toFixed(0);
		} else {
			var b = (parseInt(a) + parseInt(a * n) / 100).toFixed(0);
		}
		if (checkComma > 0 && checkDot > 0) {
			if (checkComma > checkDot) {
				var f = new Intl.NumberFormat("de-DE").format(b / 100);
			} else {
				var f = new Intl.NumberFormat("en-US").format(b / 100);
			}
		} else if (checkComma > 0 && checkDot < 0) {
			var g = t.replace(/[^0-9\.\,]/g, "");
			if (g.length - (g.indexOf(",") + 1) == 2) {
				// COMMA SEPERATOR FOR DECIMAL VAL
				var f = new Intl.NumberFormat("de-DE").format(b / 100);
			} else {
				var f = new Intl.NumberFormat("en-US").format(b);
				// No decimal Seperator
			}
		} else if (checkComma < 0 && checkDot > 0) {
			var g = t.replace(/[^0-9\.\,]/g, "");
			if (g.length - (g.indexOf(".") + 1) == 2) {
				var f = new Intl.NumberFormat("en-US").format(b / 100);
				// DOT SEPERATOR FOR DECIMAL VAL
			} else {
				var f = new Intl.NumberFormat("ed-DE").format(b);
				// No decimal Seperator
			}
		} else {
			var f = b;
			// Divide by 100
		}
		var d = c.replace("__", f);
		if (
			formats.match(/\{\{\s*(\w+)\s*\}\}/)[1] == "amount_no_decimals" &&
			d.length <= 18
		) {
			d = d.concat("00");
			f = formatMoney(d, (format = formats));
		} else {
			f = formatMoney(d, (format = formats));
		}
		return f;
	}

	function initPrices(e, n) {
		let a = readThemeSettings();
		document
			.querySelectorAll(window.vatSelector.priceSelector)
			.forEach(function(t) {
				if (!t.hasAttribute("data-b2b") || !t.hasAttribute("data-b2c")) {
					var formats = window.vatSelector.currencyCodeEnabled ?
						window.vatSelector.moneyWithCurrencyFormat :
						window.vatSelector.moneyFormat;
					var innerHtmlValue = t.innerHTML.trim();
					var filteredPrice = innerHtmlValue;
					if (
						formats.match(/\{\{\s*(\w+)\s*\}\}/)[1] ==
						"amount_no_decimals_with_comma_separator"
					) {
						filteredPrice = filteredPrice.replace(/\.00/g, "00");
						filteredPrice = filteredPrice.concat("00");
					} else if (
						formats.match(/\{\{\s*(\w+)\s*\}\}/)[1] ==
						"amount_no_decimals_with_space_separator"
					) {
						filteredPrice = filteredPrice.concat("00");
					} else if (
						formats.match(/\{\{\s*(\w+)\s*\}\}/)[1] ==
						"amount_with_apostrophe_separator"
					) {
						filteredPrice = filteredPrice.replace(/\.00/g, "00");
					} else {}
					filteredPrice = filteredPrice.replace(/\D/g, "");
					var finalPrice = filteredPrice;
					var originalPrice = finalPrice;
					if (
						formats.match(/\{\{\s*(\w+)\s*\}\}/)[1] == "amount_no_decimals" &&
						originalPrice.length <= 18
					) {
						originalPrice = originalPrice.concat("00");
						originalPrice = formatMoney(originalPrice, (format = formats));
					} else {
						originalPrice = formatMoney(originalPrice, (format = formats));
					}
					var c = readCountry(),
						d = window.vatSelector.taxConfig[c];
					if (!d.single_tax) {
						if (checkNullUndefined(d)) {
							var tg = t.getAttribute('data-product-tags');
							if (tg !== null && tg !== undefined) {
								e = calculateTagVAT(tg, d);
							}
						}
					}
					if (n === "b2c") {
						t.setAttribute("data-b2b", getPrice("b2b", finalPrice, e)),
							t.setAttribute("data-b2c", originalPrice);
					} else {
						t.setAttribute("data-b2c", getPrice("b2c", finalPrice, e)),
							t.setAttribute("data-b2b", originalPrice);
					}
				}
			});
            document
            .querySelectorAll('.vat-price-helper')
            .forEach(function(el) {
                if (!el._hasClickHandler) {
                    el.addEventListener ('click', function (event) {
                        event.stopImmediatePropagation();
                        toggleSwitch(event.target.innerHTML.includes ("exkl") ? true : false);
                    })
                }
                el._hasClickListener = true
            })
	}

	function calculateTagVAT(tt, d) {
		const tags = tt.split(',');
		const tagVATs = [];
	
		for (const tag of tags) {
		const matchingTagVAT = d.tag_base_vat.find(
			tagVAT => tagVAT[tag] !== undefined
		);
	
		if (matchingTagVAT) {
			tagVATs.push(Number(matchingTagVAT[tag]));
		}
		}
	
		const selectedVAT = tagVATs.length > 0
		? (tagVATs.length > 1
			? d.tax_amount
			: tagVATs[0]
		)
		: d.tax_amount;	
		return selectedVAT;
	}

	function changePrices(e) {
		document
			.querySelectorAll(window.vatSelector.priceSelector)
			.forEach(function(t) {
				t.getAttribute("data-pricing");
				t.setAttribute("data-pricing", e);
				var n = t.getAttribute("data-" + e);
				t.innerHTML = n;
			});
	}

	function vatSwitcherChangeAll(e) {
		if (checkNullUndefined(e)) {
			if (document.querySelector(".vat-selector-inline") !== null) {
				document.querySelectorAll(".vat-selector-inline > a").forEach(function(el) {
					el.classList.remove("active");
				});
				document.querySelectorAll('.vat-selector-inline > a[data-vat-type="' + e + '"]').forEach(function(el) {
					el.classList.add("active");
				});
			}
		}
	
		if (document.querySelector(".vat-selector-option") !== null) {
			document.querySelectorAll(".vat-selector-option").forEach(function(el) {
				let leftContent = el.querySelector(".left-content");
				let rightContent = el.querySelector(".right-content");
	
				if (e === "b2c") {
					leftContent.classList.remove("active");
					rightContent.classList.add("active");
				} else {
					leftContent.classList.add("active");
					rightContent.classList.remove("active");
				}
			});
		}
	
		var t = readTaxAmount();
		let u = readThemeSettings();
		if (t) {
			if (void 0 === e) {
				if (u.includingTax) {
					var n = "b2c";
				} else {
					var n = "b2b";
				}
				initPrices(t, n);
			} else {
				changePrices((n = e));
			}
			var a = readTranslations();
			changeAllHelper("b2b" === n ? a.b2bHelper : a.b2cHelper);
		} else {
			console.log(
				"VAT Rules for current product / collection not defined for selected country"
			);
		}
	}
	function vatSwitcherInit() {
		let a = readThemeSettings();
		vatSwitcherChangeAll();
		changeLanguage(readTranslations());
		var e = vatReadCookie("vatCountry");
		if (e == null) {
			vatEraseCookie("vatCountry");
			vatCreateCookie(
				"vatCountry",
				window.vatSelector.defaultCountry,
				a.cookie_validity
			);
		}
		var t = vatReadCookie("pricingFormat");
		if (t == null) {
			if (window.vatSelector.displayPopup) {
				document.querySelector(".vat-selector-popup").style.display = "block";
			} else {
				let a = readThemeSettings();
				vatEraseCookie("pricingFormat");
				vatCreateCookie(
					"pricingFormat",
					a.defaultPricing,
					a.cookie_validity
				);
				vatSwitcherChangeAll(a.defaultPricing);
			}
		} else {
			document.querySelector(".vat-selector-popup").style.display = "none";
			vatSwitcherChangeAll(t);
		}
	}

	function initializeInlineSelectors () {
		if (document.querySelector(".vat-selector-inline") !== null) {
			
			let themeSettings = readThemeSettings();
			let inlineSelectors = document.querySelectorAll(".vat-selector-inline");

			inlineSelectors.forEach(function(e) {

				if (!e.querySelector(".vat-selector-option")) {

					console.log ("Creating VATSelector inner HTML")
					e.innerHTML = `
						<div class="vat-selector-option">
							<div class="left-content" data-vat-type="b2b">
								${window.vatSelector.translations.sv.b2bButton}
							</div>
							<span>|</span>
							<div class="right-content" data-vat-type="b2c">
								${window.vatSelector.translations.sv.b2cButton}
							</div>
						</div>
					`;
				}
			});
		}
	}
	initializeInlineSelectors ()
	function toggleSwitch(checked) {
		let a = readThemeSettings();
		let vatType = checked ? "b2c" : "b2b";

		vatEraseCookie("pricingFormat");
		vatCreateCookie(
			"pricingFormat",
			vatType,
			a.cookie_validity
		);

		document.querySelector(".vat-selector-popup").style.display = "none";
		vatSwitcherChangeAll(vatType);
		if (document.querySelector(".vat-selector-inline") !== null) {
			document
				.querySelectorAll(
					'.vat-selector-inline a[data-vat-type="' + vatType + '"]'
				)
				.forEach(function(e) {
					e.classList.add("active");
				});
			document
				.querySelectorAll(
					'.vat-selector-inline a[data-vat-type]:not([data-vat-type="' +
					vatType +
					'"])'
				)
				.forEach(function(e) {
					e.classList.remove("active");
				});



			document
				.querySelectorAll(
					'.vat-selector-inline .vat-selector-option > div[data-vat-type="' + vatType + '"]'
				)
				.forEach(function(e) {
					e.classList.add("active");
				});

			document
				.querySelectorAll(
					'.vat-selector-inline .vat-selector-option > div[data-vat-type]:not([data-vat-type="' +
					vatType +
					'"])'
				)
				.forEach(function(e) {
					e.classList.remove("active");
				});
		}
	}


	// Add event listeners to elements with data-vat-type="b2b"
	document.querySelectorAll(".vat-selector-option .left-content[data-vat-type='b2b']").forEach(function(e) {
		e.addEventListener('click', function(event) {
            toggleSwitch (false)
		});
	});

	// Add event listeners to elements with data-vat-type="b2c"
	document.querySelectorAll(".vat-selector-option .right-content[data-vat-type='b2c']").forEach(function(e) {
		e.addEventListener('click', function(event) {
            toggleSwitch (true)
		});
	});

	document.querySelectorAll(".account-type").forEach(function(e) {
		let a = readThemeSettings();
		e.addEventListener("click", function(t) {
			vatEraseCookie("pricingFormat");
			vatCreateCookie(
				"pricingFormat",
				e.dataset.vatType,
				a.cookie_validity
			);
			document.querySelector(".vat-selector-popup").style.display = "none";
			vatSwitcherChangeAll(e.dataset.vatType);
			if (document.querySelector(".vat-selector-inline") !== null) {
				document
					.querySelectorAll(
						'.vat-selector-inline a[data-vat-type="' + e.dataset.vatType + '"]'
					)
					.forEach(function(e) {
						e.classList.add("active");
					});
				document
					.querySelectorAll(
						'.vat-selector-inline a[data-vat-type]:not([data-vat-type="' +
						e.dataset.vatType +
						'"])'
					)
					.forEach(function(e) {
						e.classList.remove("active");
					});
			}

			if (e.dataset.vatType == 'b2b') {
				document.querySelectorAll('.vat-selector-option-switch').forEach(function(checkbox) {
					checkbox.checked = false;
				});
			} else {
				document.querySelectorAll('.vat-selector-option-switch').forEach(function(checkbox) {
					checkbox.checked = true;
				});
			}
		});
	});

	document
		.querySelector(".vat-selector-popup .close-btn")
		.addEventListener("click", function(e) {
			var t = vatReadCookie("pricingFormat");
			let a = readThemeSettings();
			if (null == t || t == undefined) {
				vatEraseCookie("pricingFormat");
				vatCreateCookie(
					"pricingFormat",
					a.defaultPricing,
					a.cookie_validity
				);
				vatSwitcherChangeAll(a.defaultPricing);
				document.querySelector(".vat-selector-popup").style.display = "none";
			} else {
				vatSwitcherChangeAll(t);
				document.querySelector(".vat-selector-popup").style.display = "none";
			}
		});
	document.addEventListener('variant:update', event => {
		vatSwitcherChangeAll ()
	})
	document.addEventListener('section:rendered', event => {
		vatSwitcherChangeAll(t);
		document.querySelector(".vat-selector-popup").style.display = "none";
	});
	document.addEventListener("DOMContentLoaded", function(e) {
		if (readAppStatus()) {
			if (Object.keys(window.vatSelector.translations).length) {
				setTimeout(vatSwitcherInit, 100);
			} else {
				document.querySelector(".vat-selector-popup").style.display = "none";
				console.log("Translation strings not defined");
			}
		} else {
			document.querySelector(".vat-selector-popup").style.display = "none";
			console.log("VAT Switcher is disabled");
		}
	});

	var taxSelectorobserver = new MutationObserver(function(
		mutationsList,
		taxSelectorobserver
	) {
		var vatInit = false;
		var vatMutation = false;
		mutationsList.forEach(function(m) {
			if (m.type === "childList") {
				var checkPriceElement = m.target.querySelectorAll(
					window.vatSelector.priceSelector
				);
				if (checkPriceElement !== null) {
					checkPriceElement.forEach((el) => {
						if (vatInit === false) {
							var newData = el.textContent,
								b2cPrice = el.dataset.b2c,
								b2bPrice = el.dataset.b2b,
								pricingFormat = el.dataset.pricing,
								formattedNewData =
								newData !== undefined ?
								newData.replace(/[^0-9a-zA-Z.]/g, "") :
								"",
								formattedB2cPricing =
								b2cPrice !== undefined ?
								b2cPrice.replace(/[^0-9a-zA-Z.]/g, "") :
								"",
								formattedB2bPricing =
								b2bPrice !== undefined ?
								b2bPrice.replace(/[^0-9a-zA-Z.]/g, "") :
								"";
							if (
								pricingFormat === undefined ||
								formattedB2bPricing === undefined ||
								formattedB2cPricing === undefined ||
								formattedNewData === undefined
							) {
								vatMutation = true;
								vatInit = true;
								setTimeout(vatSwitcherInit, 100);
								taxSelectorobserver.disconnect();
								setTimeout(function() {
									taxSelectorobserver.observe(document.querySelector("body"), {
										characterData: false,
										childList: true,
										attributes: false,
										subtree: true,
									});
								}, 500);
							} else {
								if (
									pricingFormat === "b2b" &&
									formattedB2bPricing !== formattedNewData
								) {
									vatMutation = true;
									vatInit = true;
									taxSelectorobserver.disconnect();
									setTimeout(vatSwitcherInit, 100);
									setTimeout(function() {
										taxSelectorobserver.observe(
											document.querySelector("body"), {
												characterData: false,
												childList: true,
												attributes: false,
												subtree: true,
											}
										);
									}, 500);
								} else if (
									pricingFormat === "b2c" &&
									formattedB2cPricing !== formattedNewData
								) {
									vatMutation = true;
									vatInit = true;
									taxSelectorobserver.disconnect();
									setTimeout(vatSwitcherInit, 100);
									setTimeout(function() {
										taxSelectorobserver.observe(
											document.querySelector("body"), {
												characterData: false,
												childList: true,
												attributes: false,
												subtree: true,
											}
										);
									}, 500);
								}
							}
						}
					});
				}
			}
		});
	});

	if (window.vatSelector.currentProduct !== undefined) {
		window.addEventListener("load", (event) => {
			setTimeout(function() {
				taxSelectorobserver.observe(document.querySelector("body"), {
					characterData: false,
					childList: true,
					attributes: false,
					subtree: true,
				});
			}, 500);
		});
	}
}